import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Cookies from "js-cookie";
import axios from "axios";
import Loader from "../components/Loader";
import ViewModal from "../components/ViewModal";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const apiKey = process.env.REACT_APP_API_KEY;

export default function AttorneyDetails() {
  const { country } = useParams();
  const isAdmin = Cookies.get("user_role") === "Administrator";
  const headers = { Authorization: apiKey, "Content-Type": "application/json" };

  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [form, setForm] = useState({
    name: "",
    phoneNumber: "",
    email: "",
    address: "",
    website: "",
  });
  const [viewOpen, setViewOpen] = useState(false);
  const [selected, setSelected] = useState(null);

  const loadItems = () => {
    setLoading(true);
    axios
      .get(`${BASE_URL}/getattorneys/${encodeURIComponent(country)}`, { headers })
      .then((res) => {
        setItems(res.data || []);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  useEffect(() => {
    loadItems();
  }, [country]);

  const resetForm = () => {
    setEditingId(null);
    setForm({ name: "", phoneNumber: "", email: "", address: "", website: "" });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const payload = {
      Country: country,
      Name: form.name.trim(),
      PhoneNumber: form.phoneNumber.trim(),
      Email: form.email.trim(),
      Address: form.address.trim(),
      Website: form.website.trim(),
    };
    if (!payload.Name || !payload.PhoneNumber || !payload.Email || !payload.Address || !payload.Website) {
      alert("All fields required.");
      return;
    }
    if (editingId) {
      axios
        .put(`${BASE_URL}/updateattorney`, { ...payload, Id: editingId }, { headers })
        .then(() => {
          resetForm();
          loadItems();
        })
        .catch((error) => console.log(error));
      return;
    }
    axios
      .post(`${BASE_URL}/addattorney`, payload, { headers })
      .then(() => {
        resetForm();
        loadItems();
      })
      .catch((error) => console.log(error));
  };

  const deleteItem = (id) => {
    if (!window.confirm("Delete this attorney detail?")) return;
    axios
      .delete(`${BASE_URL}/deleteattorney/${id}`, { headers })
      .then(() => {
        if (editingId === id) resetForm();
        loadItems();
      })
      .catch((error) => console.log(error));
  };

  const copyItem = async (item) => {
    const text = `Name: ${item.Name}\nPhone: ${item.PhoneNumber}\nEmail: ${item.Email}\nAddress: ${item.Address}\nWebsite: ${item.Website}`;
    try {
      await navigator.clipboard.writeText(text);
      alert("Copied.");
    } catch (error) {
      console.log(error);
    }
  };

  if (loading) return <Loader />;

  return (
    <div className="container">
      <h2>{country} - Attorney Details</h2>
      <br />
      {isAdmin && (
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-sm-2">
              <input className="form-control" placeholder="Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
            </div>
            <div className="col-sm-2">
              <input className="form-control" placeholder="Phone Number" value={form.phoneNumber} onChange={(e) => setForm({ ...form, phoneNumber: e.target.value })} />
            </div>
            <div className="col-sm-2">
              <input className="form-control" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
            </div>
            <div className="col-sm-3">
              <input className="form-control" placeholder="Address" value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} />
            </div>
            <div className="col-sm-3">
              <input className="form-control" placeholder="Website" value={form.website} onChange={(e) => setForm({ ...form, website: e.target.value })} />
            </div>
          </div>
          <br />
          <button className="btn btn-primary" type="submit">{editingId ? "Update" : "Add"}</button>
          {editingId && (
            <button className="btn btn-secondary ms-2" type="button" onClick={resetForm}>Cancel</button>
          )}
          <br />
          <br />
        </form>
      )}

      <table className="table table-striped table-dark crm-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Phone</th>
            <th>Email</th>
            <th>Address</th>
            <th>Website</th>
            <th className="crm-col-actions">View</th>
            <th className="crm-col-actions">Copy</th>
            {isAdmin && (
              <>
                <th className="crm-col-actions">Edit</th>
                <th className="crm-col-actions">Delete</th>
              </>
            )}
          </tr>
        </thead>
        <tbody>
          {items.map((item) => (
            <tr key={item.Id}>
              <td>{item.Name}</td>
              <td>{item.PhoneNumber}</td>
              <td>{item.Email}</td>
              <td style={{ maxWidth: "260px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                {item.Address}
              </td>
              <td style={{ maxWidth: "220px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                {item.Website}
              </td>
              <td className="crm-col-actions">
                <button
                  className="btn btn-sm btn-light crm-icon-btn"
                  onClick={() => {
                    setSelected(item);
                    setViewOpen(true);
                  }}
                  title="View"
                >
                  <i className="bi bi-eye"></i>
                </button>
              </td>
              <td className="crm-col-actions">
                <button className="btn btn-sm btn-info crm-icon-btn" onClick={() => copyItem(item)} title="Copy">
                  <i className="bi bi-clipboard"></i>
                </button>
              </td>
              {isAdmin && (
                <>
                  <td className="crm-col-actions">
                    <button className="btn btn-sm btn-light crm-icon-btn" onClick={() => {
                      setEditingId(item.Id);
                      setForm({
                        name: item.Name,
                        phoneNumber: item.PhoneNumber,
                        email: item.Email,
                        address: item.Address,
                        website: item.Website,
                      });
                    }} title="Edit">
                      <i className="bi bi-pencil-square"></i>
                    </button>
                  </td>
                  <td className="crm-col-actions">
                    <button className="btn btn-sm btn-danger crm-icon-btn" onClick={() => deleteItem(item.Id)} title="Delete">
                      <i className="bi bi-trash3"></i>
                    </button>
                  </td>
                </>
              )}
            </tr>
          ))}
          {items.length === 0 && (
            <tr><td colSpan={isAdmin ? 9 : 7} className="text-center">No records found.</td></tr>
          )}
        </tbody>
      </table>

      <ViewModal
        open={viewOpen}
        title={selected ? `Attorney - ${selected.Name}` : "Attorney"}
        onClose={() => setViewOpen(false)}
      >
        {selected && (
          <div className="p-2">
            <div className="mb-3">
              <div className="text-muted">
                <strong>Country:</strong> {country}
              </div>
            </div>
            <div className="row g-3">
              <div className="col-md-6">
                <div className="p-3" style={{ border: "1px solid #e5e5e5", borderRadius: "10px" }}>
                  <div><strong>Name:</strong> {selected.Name}</div>
                  <div><strong>Phone:</strong> {selected.PhoneNumber}</div>
                  <div><strong>Email:</strong> {selected.Email}</div>
                  <div><strong>Website:</strong> {selected.Website}</div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="p-3" style={{ border: "1px solid #e5e5e5", borderRadius: "10px", whiteSpace: "pre-wrap" }}>
                  <div style={{ marginBottom: "6px" }}><strong>Address</strong></div>
                  {selected.Address}
                </div>
              </div>
            </div>
          </div>
        )}
      </ViewModal>
    </div>
  );
}
